"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Definable_1 = __importDefault(require("./Definable"));
const getAudioSource_1 = __importDefault(require("../functions/definables/getAudioSource"));
class MusicTrack extends Definable_1.default {
    constructor(slug, { audioSourceSlug }) {
        super(slug);
        this._audioSourceSlug = audioSourceSlug;
    }
    get audioSource() {
        return (0, getAudioSource_1.default)(this._audioSourceSlug);
    }
    applyVolume() {
        const mainVolumeElement = document.getElementById("main-volume");
        const musicVolumeElement = document.getElementById("music-volume");
        if (mainVolumeElement instanceof HTMLInputElement && musicVolumeElement instanceof HTMLInputElement) {
            const audioSource = this.audioSource;
            const mainVolume = Number(mainVolumeElement.value) / 100;
            const musicVolume = Number(musicVolumeElement.value) / 100;
            audioSource.applyVolume(mainVolume * musicVolume);
        }
    }
}
exports.default = MusicTrack;
